import { LoadingSpinnerContainer } from 'component/progress/loading-spinner';
import { useFirstEvalConversationKey } from 'data/ranking-eval';
import { useFocusEffect, useRouter } from 'expo-router';
import { rankingEvalModuleQuery, useModule } from 'system/structure-modules';
import { useSiloKey } from 'util/datastore';

export default function RankingEvalSideBySideRedirect() {
    const router = useRouter();
    const siloKey = useSiloKey();
    const instanceKey = useFirstEvalConversationKey();
    const { NoEvalConversationsScreen } = useModule(rankingEvalModuleQuery);

    useFocusEffect(() => {
        if (instanceKey) {
            router.replace(
                {
                    pathname: './[instanceKey]',
                    params: {
                        siloKey,
                        instanceKey,
                    },
                },
                {
                    relativeToDirectory: true,
                },
            );
        }
    });

    if (instanceKey === null) return <NoEvalConversationsScreen />;
    return <LoadingSpinnerContainer />;
}
